import { makeStyles, theme } from '@policygenius/mortar';

const styles = makeStyles(() => ({
  askWrapper: {
    marginBottom: theme.spacing('large'),
    padding: [0, theme.spacing('medium')],
  },
}));

export default styles;
